import {
  ProjectConfiguration,
  stringifyEnvVariableAsJsonValueOrFail,
  stringifyEnvVariableOrFail,
} from '../index'

const prjConfiguration: ProjectConfiguration<'coche'> = {
  clientEnvResolver: (buildEnv, processEnv): ProcessEnv => {
    return {
      APP_HOST_PORT: stringifyEnvVariableOrFail(processEnv, 'APP_HOST_PORT'),
      APP_HOST_URL: stringifyEnvVariableOrFail(processEnv, 'APP_HOST_URL'),

      BACKEND_API_URL: stringifyEnvVariableOrFail(processEnv, 'BACKEND_API_URL'),
      BUILD_ENV: JSON.stringify(buildEnv),

      COLD_LEADS_PHONE_NUMBER: stringifyEnvVariableOrFail(processEnv, 'COLD_LEADS_PHONE_NUMBER'),

      CONTRATACION_DOMAIN: stringifyEnvVariableOrFail(process.env, 'CONTRATACION_DOMAIN'),

      DATADOG_APPLICATION_ID: stringifyEnvVariableOrFail(processEnv, 'DATADOG_APPLICATION_ID'),
      DATADOG_CLIENT_TOKEN: stringifyEnvVariableOrFail(processEnv, 'DATADOG_CLIENT_TOKEN'),
      DATADOG_SERVICE_NAME: stringifyEnvVariableOrFail(processEnv, 'DATADOG_SERVICE_NAME'),
      DTS_SESSION_COOKIE_DOMAIN: stringifyEnvVariableOrFail(
        processEnv,
        'DTS_SESSION_COOKIE_DOMAIN'
      ),

      GTM_AUTH_CODE: stringifyEnvVariableOrFail(processEnv, 'GTM_AUTH_CODE'),
      GTM_ID: stringifyEnvVariableOrFail(processEnv, 'GTM_ID'),
      GTM_PREVIEW_ID: stringifyEnvVariableOrFail(processEnv, 'GTM_PREVIEW_ID'),

      IS_BUILD_OPTIMIZED: stringifyEnvVariableAsJsonValueOrFail(processEnv, 'IS_BUILD_OPTIMIZED'),
      IS_CROSS_DOMAIN_COOKIE_ENABLED: stringifyEnvVariableAsJsonValueOrFail(
        processEnv,
        'IS_CROSS_DOMAIN_COOKIE_ENABLED'
      ),
      IS_DATADOG_ENABLED: stringifyEnvVariableAsJsonValueOrFail(processEnv, 'IS_DATADOG_ENABLED'),
      IS_DEV_ROUTER_ENABLED: stringifyEnvVariableAsJsonValueOrFail(
        processEnv,
        'IS_DEV_ROUTER_ENABLED'
      ),
      IS_DYNAMIC_FLAGS_FETCHING_ENABLED: stringifyEnvVariableAsJsonValueOrFail(
        processEnv,
        'IS_DYNAMIC_FLAGS_FETCHING_ENABLED'
      ),
      IS_ELM_BODY_PATCH_ENABLED: stringifyEnvVariableAsJsonValueOrFail(
        processEnv,
        'IS_ELM_BODY_PATCH_ENABLED'
      ),
      IS_PRIVATE_LOG_ENVIRONMENT: stringifyEnvVariableAsJsonValueOrFail(
        processEnv,
        'IS_PRIVATE_LOG_ENVIRONMENT'
      ),
      IS_ZENDESK_SIMULATED: stringifyEnvVariableAsJsonValueOrFail(
        processEnv,
        'IS_ZENDESK_SIMULATED'
      ),

      LAUNCHDARKLY_CLIENT_ID: stringifyEnvVariableOrFail(processEnv, 'LAUNCHDARKLY_CLIENT_ID'),

      PRIMA_PUBLIC_HOST: stringifyEnvVariableOrFail(processEnv, 'PRIMA_PUBLIC_HOST'),
      PRIVACY_POLICY_PAGE_URL: stringifyEnvVariableOrFail(processEnv, 'PRIVACY_POLICY_PAGE_URL'),

      TERMS_AND_CONDITIONS_PAGE_URL: stringifyEnvVariableOrFail(
        processEnv,
        'TERMS_AND_CONDITIONS_PAGE_URL'
      ),
      TURNSTILE_SITEKEY: stringifyEnvVariableOrFail(processEnv, 'TURNSTILE_SITEKEY'),

      USERPILOT_TOKEN: stringifyEnvVariableOrFail(processEnv, 'USERPILOT_TOKEN'),

      VERSION: stringifyEnvVariableOrFail(processEnv, 'VERSION'),

      WARM_LEADS_PHONE_NUMBER: stringifyEnvVariableOrFail(processEnv, 'WARM_LEADS_PHONE_NUMBER'),
    }
  },
  transpilerConfiguration: {
    manifest: {
      appDescription:
        'Calcula tu seguro de coche online de forma rápida y sencilla. Consigue un presupuesto personalizado con las mejores coberturas, al mejor precio.',
      appName: 'Prima',
      lang: 'es-ES',
    },
    preRenderedRoutes: ['coche', '404'],
    robotsTxt: {
      policy: [
        {
          allow: '/',
          userAgent: '*',
        },
      ],
    },
    startUrl: 'coche',
  },
}

/**
 * Node.js Env redeclaration. Is used by FE code too for type hints. Since is not declared
 * as an importable type we redeclare it entirely instead of extending the package type with TZ field
 *
 * This Env object is shared between webpack and the transpiled client through typescript global declarations
 * In order to reduce risk it must be Json stringified, and is "type" checked at build time
 *
 * if you need one of these values during webpack phase ***REMEMBER TO JSON PARSE THEM***
 */
export interface ProcessEnv extends NodeJS.Dict<string> {
  APP_HOST_PORT: string
  APP_HOST_URL: string

  BACKEND_API_URL: string
  BUILD_ENV: string

  COLD_LEADS_PHONE_NUMBER: string

  DATADOG_APPLICATION_ID: string
  DATADOG_CLIENT_TOKEN: string
  DATADOG_SERVICE_NAME: string
  DTS_SESSION_COOKIE_DOMAIN: string

  GTM_AUTH_CODE: string
  GTM_ID: string
  GTM_PREVIEW_ID: string

  IS_BUILD_OPTIMIZED: string
  IS_CROSS_DOMAIN_COOKIE_ENABLED: string
  IS_DATADOG_ENABLED: string
  IS_DEV_ROUTER_ENABLED: string
  IS_DYNAMIC_FLAGS_FETCHING_ENABLED: string
  IS_ELM_BODY_PATCH_ENABLED: string
  IS_PRIVATE_LOG_ENVIRONMENT: string
  IS_ZENDESK_SIMULATED: string

  LAUNCHDARKLY_CLIENT_ID: string

  TURNSTILE_SITEKEY: string
  TZ?: string
  VERSION: string

  WARM_LEADS_PHONE_NUMBER: string
}
export default prjConfiguration
